/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_TitleInputs */

const en_sidebar_title = /** @type {(inputs: Sidebar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidebar`)
};

const pt_br2_sidebar_title = /** @type {(inputs: Sidebar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra lateral`)
};

/**
* | output |
* | --- |
* | "Sidebar" |
*
* @param {Sidebar_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const sidebar_title = /** @type {((inputs?: Sidebar_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_title(inputs)
	return pt_br2_sidebar_title(inputs)
});